import Axios from "../config/Axios";
import {
    GET_ALL_PROJECTS_REQUEST,
    GET_ALL_PROJECTS_SUCCESS,
    GET_ALL_PROJECTS_FAIL,
    CREATE_PROJECT_REQUEST,
    CREATE_PROJECT_SUCCESS,
    CREATE_PROJECT_FAIL,
    GET_RECENT_FILES_REQUEST,
    GET_RECENT_FILES_SUCCESS,
    GET_RECENT_FILES_FAIL,
    GET_FILES_REQUEST,
    GET_FILES_SUCCESS,
    GET_FILES_FAIL,
    CREATE_FILE_REQUEST,
    CREATE_FILE_SUCCESS,
    CREATE_FILE_FAIL,
    GET_BOOKMARK_FILES_REQUEST,
    GET_BOOKMARK_FILES_SUCCESS,
    GET_BOOKMARK_FILES_FAIL,
    EDIT_FILE_REQUEST,
    EDIT_FILE_SUCCESS,
    EDIT_FILE_FAIL,
    DELETE_FILE_REQUEST,
    DELETE_FILE_SUCCESS,
    DELETE_FILE_FAIL,
    RENAME_FILE_REQUEST,
    RENAME_FILE_SUCCESS,
    RENAME_FILE_FAIL,
    RENAME_FOLDER_REQUEST,
    RENAME_FOLDER_SUCCESS,
    RENAME_FOLDER_FAIL,
    DUPLICATE_FILE_REQUEST,
    DUPLICATE_FILE_SUCCESS,
    DUPLICATE_FILE_FAIL,
    MOVE_FILE_REQUEST,
    MOVE_FILE_SUCCESS,
    MOVE_FILE_FAIL,
} from '../constants/projectConstants';

const fetchAllProjects = (workspaceId) => async (dispatch, getState) => {
    try {
        dispatch({
            type: GET_ALL_PROJECTS_REQUEST,
        })

        const { userLogin: { userInfo } } = getState();

        const config = {
            headers: {
                // 'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            }
        }

        const { data } = await Axios.get(`/project/folders/${workspaceId}`, config);

        dispatch({
            type: GET_ALL_PROJECTS_SUCCESS,
            payload: data
        })

    } catch (error) {
        dispatch({
            type: GET_ALL_PROJECTS_FAIL,
            payload: error.message,
        })
    }
}

const createNewProject = (projectInfo) => async (dispatch, getState) => {
    try {
        dispatch({
            type: CREATE_PROJECT_REQUEST,
        })

        const { userLogin: { userInfo } } = getState();

        const config = {
            headers: {
                // 'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            }
        }

        const { data } = await Axios.post("/project/folder/create", projectInfo, config);

        dispatch({
            type: CREATE_PROJECT_SUCCESS,
            payload: data
        })

    } catch (error) {
        dispatch({
            type: CREATE_PROJECT_FAIL,
            payload: error.message,
        })
    }
}

const fetchRecentFiles = (workspaceId) => async (dispatch, getState) => {
    try {
        dispatch({
            type: GET_RECENT_FILES_REQUEST,
        })

        const { userLogin: { userInfo } } = getState();

        const config = {
            headers: {
                // 'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            }
        }

        const { data } = await Axios.get(`/project/file/recent/${workspaceId}`, config);
       

        dispatch({
            type: GET_RECENT_FILES_SUCCESS,
            payload: data
        })

    } catch (error) {
        dispatch({
            type: GET_RECENT_FILES_FAIL,
            payload: error.message,
        })
    }
}

const fetchBookmarkFiles = (workspaceId) => async (dispatch, getState) => {
    try {
        dispatch({
            type: GET_BOOKMARK_FILES_REQUEST,
        })

        const { userLogin: { userInfo } } = getState();

        const config = {
            headers: {
                // 'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            }
        }

        const { data } = await Axios.get(`/project/file/bookmark/${workspaceId}`, config);

        dispatch({
            type: GET_BOOKMARK_FILES_SUCCESS,
            payload: data
        })

    } catch (error) {
        dispatch({
            type: GET_BOOKMARK_FILES_FAIL,
            payload: error.message,
        })
    }
}

const fetchAllFiles = (workspaceId) => async (dispatch, getState) => {
    try {
        dispatch({
            type: GET_FILES_REQUEST,
        })

        const { userLogin: { userInfo } } = getState();

        const config = {
            headers: {
                // 'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            }
        }

        const { data } = await Axios.get(`/project/file/${workspaceId}`, config);

        dispatch({
            type: GET_FILES_SUCCESS,
            payload: data
        })

    } catch (error) {
        dispatch({
            type: GET_FILES_FAIL,
            payload: error.message,
        })
    }
}

const createNewFile = (fileInfo) => async (dispatch, getState) => {
    try {
        dispatch({
            type: CREATE_FILE_REQUEST,
        })

        const { userLogin: { userInfo } } = getState();

        const config = {
            headers: {
                // 'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            }
        }

        const { data } = await Axios.post("/project/file/create", fileInfo, config);

        dispatch({
            type: CREATE_FILE_SUCCESS,
            payload: data
        })

    } catch (error) {
        dispatch({
            type: CREATE_FILE_FAIL,
            payload: error.message,
        })
    }
}

const editFile = (fileInfo) => async (dispatch, getState) => {
    try {
        dispatch({
            type: EDIT_FILE_REQUEST,
        })

        const { userLogin: { userInfo } } = getState();

        const config = {
            headers: {
                // 'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            }
        }

        const { data } = await Axios.post("/project/file/edit", fileInfo, config);

        dispatch({
            type: EDIT_FILE_SUCCESS,
            payload: data
        })

    } catch (error) {
        dispatch({
            type: EDIT_FILE_FAIL,
            payload: error.message,
        })
    }
}

const deleteFile = (fileId) => async (dispatch, getState) => {
    try {
        dispatch({
            type: DELETE_FILE_REQUEST,
        })

        const { userLogin: { userInfo } } = getState();

        const config = {
            headers: {
                // 'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            }
        }

        const { data } = await Axios.delete(`/project/file/delete/${fileId}`, config);

        dispatch({
            type: DELETE_FILE_SUCCESS,
            payload: data
        })

    } catch (error) {
        dispatch({
            type: DELETE_FILE_FAIL,
            payload: error.message,
        })
    }
}

const renameFile = (fileInfo) => async (dispatch, getState) => {
    try {
        dispatch({
            type: RENAME_FILE_REQUEST,
        })

        const { userLogin: { userInfo } } = getState();

        const config = {
            headers: {
                // 'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            }
        }

        const { data } = await Axios.post("/project/file/rename", fileInfo, config);

        dispatch({
            type: RENAME_FILE_SUCCESS,
            payload: data
        })

    } catch (error) {
        dispatch({
            type: RENAME_FILE_FAIL,
            payload: error.message,
        })
    }
}

const renameFolder = (folderInfo) => async (dispatch, getState) => {
    try {
        dispatch({
            type: RENAME_FOLDER_REQUEST,
        })

        const { userLogin: { userInfo } } = getState();

        const config = {
            headers: {
                // 'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            }
        }

        const { data } = await Axios.post("/project/folder/rename", folderInfo, config);

        dispatch({
            type: RENAME_FOLDER_SUCCESS,
            payload: data
        })

    } catch (error) {
        dispatch({
            type: RENAME_FOLDER_FAIL,
            payload: error.message,
        })
    }
}

const duplicateFile = (fileInfo) => async (dispatch, getState) => {
    try {
        dispatch({
            type: DUPLICATE_FILE_REQUEST,
        })

        const { userLogin: { userInfo } } = getState();

        const config = {
            headers: {
                // 'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            }
        }

        const { data } = await Axios.post("/project/file/copy", fileInfo, config);

        dispatch({
            type: DUPLICATE_FILE_SUCCESS,
            payload: data
        })

    } catch (error) {
        dispatch({
            type: DUPLICATE_FILE_FAIL,
            payload: error.message,
        })
    }
}

const moveFile = (fileInfo) => async (dispatch, getState) => {
    try {
        dispatch({
            type: MOVE_FILE_REQUEST,
        })

        const { userLogin: { userInfo } } = getState();

        const config = {
            headers: {
                // 'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            }
        }

        const { data } = await Axios.post("/project/file/move", fileInfo, config);

        dispatch({
            type: MOVE_FILE_SUCCESS,
            payload: data
        })

    } catch (error) {
        dispatch({
            type: MOVE_FILE_FAIL,
            payload: error.message,
        })
    }
}

export {
    fetchAllProjects,
    createNewProject,
    fetchRecentFiles,
    fetchBookmarkFiles,
    fetchAllFiles,
    createNewFile,
    editFile,
    deleteFile,
    renameFile,
    renameFolder,
    duplicateFile,
    moveFile
}
